import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@/sass/vuetify.sass';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#28A0F6',
        lightblue: '#D9E7FC',
        bgLogin: '#142769',
        menuActive: '#28A0F6',
        primarylight: '#6d7fbc',
        secondblue: '#2196F3',
        thirdblue: '#3367D5',
        secondary: '#F0F2F7',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        softGreen: '#34CFAA',
        warning: '#FFC107',
        greydark: '#7b7b7b',
        greylight: '#6D788B',
        darkblue: '#1B2942',
        teal: '#01CFC2',
        textlightgrey: '#B9B9B9',
        textblack: '#404E67',
        lightblack: '#303030',
        bluedark: '#425069',
        bgTotal: '#e5eafb',
        bgTotalDark: '#b7c5fb',
        softpink: '#fff4f2',
        softRed: '#FA576E',
        blueCloud: '#66C7FF',
        bluePurple: '#4B71F0',
        lime: '#FC9A27',
        chartColor: '#1abc9c',
        flatblue: '#5273E8',
        blackFont: '#333333',
        blueMenu: '#404E67',
        bluedarken: '#28A0F6',
        primary2: '#28A0F6', // alias for bluedarken
        textGrey: '#BABFC7',
        bluegrey: '#98A3B5',
        ioSearch: '#f5f5f5',
        ashBlue: '#596F9C',
        grayLight: '#98A3B5',
        grayNaturan: '#BDBDBD',
        orangeWarning: '#FF8B49'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
});
